<template lang="pug">
.terms-of-service(:class="[{ spacing }]")
  p
    | {{ $t("terms_of_service.terms") }}{{ ' ' }}
    a(href="/legal/terms-of-use", target="_blank") {{ $t("terms_of_service.terms_of_use") }}
    |  {{ $t("terms_of_service.and") }}{{ ' ' }}
    a(href="/legal/privacy-policy-platform", target="_blank") {{ $t("terms_of_service.privacy_policy") }}
</template>

<script>

export default {
  name: 'terms-of-service',
  props: {
    spacing: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
@import "assets/styles/application.scss";

$height: 30px;
$border-radius: 4px;

.terms-of-service {
  display: flex;
  align-items: center;
  height: $height;
  border-radius: $border-radius $border-radius 0 0;

  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: .2px;

  &.spacing {
    justify-content: center;
    padding: 0 12px;
  }

  &.background--default {
    background-color: transparent;

    &.spacing {
      margin-bottom: 10px;
    }
  }

  p {
    margin: 0;
  }

  a {
    @include focus-visible-outline;
    border-radius: 4px;
  }
}
</style>
